﻿import { FIQAssist } from "../app";
import { Inject, Injectable } from "@fiqas/angular-utils";
import { Memoize, LocalStorage } from "@fiqas/utils";
import { LocalizationData } from "../models/localization";
import * as Rx from "rxjs"

@Injectable({
    module: FIQAssist,
    selector: TranslationService.selector
})
export class TranslationService {
    public static selector = "TranslationService"
    private loaded;
    private _translationTable: { [key: string]: LocalizationData };

    constructor(
        @Inject('$http') private $http: ng.IHttpService,
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject('$q') private $q: ng.IQService
    ) {
        $timeout().then(() => { var _ = this.translationData; })
        this.onLoaded = $q<void>(resolver => this._onLoaded = resolver);
        this.onLoadedLocal = $q<void>(resolver => this._onLoadedLocal = resolver);
    }

    private _onLoadedLocal: ng.IQResolveReject<void>;
    private _onLoaded: ng.IQResolveReject<void>;
    public onLoadedLocal: angular.IPromise<void>;
    public onLoaded: angular.IPromise<void>;

    private get translationTable(): { [key: string]: LocalizationData } {
        if (!this._translationTable) {
            var cached = localStorage.getItem('_translationData');
            this._translationTable = cached ? JSON.parse(cached) : {};
            this.local.then(data => {
                this._local = (data.length == 2) ? `${data}-${data.toUpperCase()}` : data;
                this._onLoadedLocal();
            });
            this.translationData.then(data => {
                for (let d of data)
                    this._translationTable[d.name] = d;
                localStorage['_translationData'] = JSON.stringify(this._translationTable);
                this.loaded = true;
                this._onLoaded();
            });
        }
        return this._translationTable;
    }

    @Memoize()
    private get translationData() {
        var p = this.getAllTranslations("Global");
        p.catch(() => this.translationData = null);
        return p;
    }
    private set translationData(_) { }

    private async getAllTranslations(filename: string) {
        var url = `api/translation/${filename}`;
        var response = await this.$http.get<LocalizationData[]>(url);
        return response.data;
    }

    private _local: string;
    @Memoize()
    private get local() {
        var local = this.getLocalName();
        local.catch(() => this._local = 'nl-NL')
        return local;
    }
    private set local(_local) { }
    private async getLocalName() {
        var url = `api/translation/local`;
        var response = await this.$http.get<string>(url);
        return response.data;
    }
    public getLocal() {
        (async () => (await this.onLoadedLocal))();
        return this._local;
    }

    public TranslateObservable(key: string) {
        var subject = new Rx.Subject<string>();
        this.$timeout().then(() => {
            if (!this.loaded)
                subject.next("loading...");
            this.translationData.then(_ => {
                subject.next(this.Translate(key));
                subject.complete();
            })
        });
        return subject.asObservable();
    }

    public async TranslateAsync(key: string, returnundefined: boolean = false) {
        var _ = await this.translationData;
        var item = this.translationTable[key.toUpperCase()];
        return item ? item.value : (returnundefined) ? undefined : key;
    }

    public async FormatAsync(key: string, args: string[], returnundefined: boolean = false) {
        var _ = await this.translationData;
        var item = this.translationTable[key.toUpperCase()];
        return item ? item.value.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined' ? args[number] : match;
        }) : (returnundefined) ? undefined : key;
    }

    public Translate(key: string, returnundefined: boolean = false): string {
        if (key) {
            var t = this.translationTable[key.toUpperCase()];
            return t ? t.value : !this.loaded ? 'loading...' : (returnundefined) ? undefined : key;
        }
        return key;
    }

    public Format(key: string, args: string[], returnundefined: boolean = false) {
        if (key) {
            var t = this.translationTable[key.toUpperCase()];
            return t ? t.value.replace(/{(\d+)}/g, function (match, number) {
                return typeof args[number] != 'undefined' ? args[number] : match;
            }) : !this.loaded ? 'loading...' : (returnundefined) ? undefined : key;
        }
        return key;
    }
}
